import { Box, Tooltip } from "@mui/material"

import ItemContainer from "@layouts/main_layout/sub_components/navigation_panel/sub_components/item_container"

import { useLeftNavigationContext } from "@contexts/left_navigation_context"
import styles from "./styles"

export default function NavigationButton({
  children,
  target,
  tooltip
}: {
  children: React.ReactNode
  target: string
  tooltip: string
}) {
  const { currentPathname, navigate } = useLeftNavigationContext()

  function go() {
    navigate(target)
  }

  const isSelected = currentPathname.startsWith(target)

  return (
    <Tooltip
      title={tooltip}
      disableFocusListener
      disableTouchListener
      placement="right"
    >
      <Box sx={{ cursor: "pointer" }} onClick={go}>
        <ItemContainer>
          <ItemContainer sx={styles.activeBg(isSelected)} />
          <Box sx={styles.outletContainer(isSelected)}>{children}</Box>
        </ItemContainer>
      </Box>
    </Tooltip>
  )
}
